import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { PROFILE_URL, COMPANY_TAGLINE, COMPANY_WHATSAPP } from "@/data/founders";

const WA_TEXT = encodeURIComponent(
  "Hello ASCEND Finance Group, I'd like to connect."
);

export const InvalidLink = () => (
  <div
    data-testid="invalid-link"
    className="relative flex h-[100dvh] flex-col items-center justify-center overflow-hidden bg-navy-950 px-8 text-center"
  >
    <div className="ambient-light" aria-hidden="true" />
    <div className="vignette" aria-hidden="true" />
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="relative z-10 flex max-w-sm flex-col items-center"
    >
      <img
        src={`${process.env.PUBLIC_URL}/assets/ascend-logo.png`}
        alt="ASCEND Finance Group"
        className="logo-img w-40"
        draggable={false}
      />
      <p
        data-testid="landing-tagline"
        className="mt-6 max-w-xs text-sm leading-relaxed text-white/75"
      >
        {COMPANY_TAGLINE}
      </p>
      <span className="mt-7 h-px w-12 bg-gold/50" />
      <h1 className="mt-6 font-display text-2xl font-semibold text-white">
        Personal card link required
      </h1>
      <p
        data-testid="invalid-link-message"
        className="mt-3 text-sm leading-relaxed text-white/60"
      >
        This page opens a co-founder&apos;s digital business card. Please use
        the personal card link you were sent.
      </p>
      <a
        href={`https://wa.me/${COMPANY_WHATSAPP}?text=${WA_TEXT}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="landing-whatsapp-button"
        className="mt-8 flex items-center gap-2.5 rounded-full border border-gold/50 bg-gold/10 px-6 py-2.5 text-[11px] font-medium tracking-[0.3em] text-gold transition-colors duration-300 hover:border-gold hover:bg-gold/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/60"
      >
        <MessageCircle size={14} strokeWidth={1.75} />
        <span className="pl-[0.3em]">CHAT ON WHATSAPP</span>
      </a>
      <a
        href={PROFILE_URL}
        data-testid="invalid-link-home"
        className="mt-6 border-b border-gold/40 pb-1.5 pl-[0.35em] text-[11px] font-medium tracking-[0.35em] text-gold/80 transition-colors duration-300 hover:border-gold hover:text-gold-light"
      >
        RETURN TO ASCEND CARD
      </a>
    </motion.div>
  </div>
);
